import request from './request';

const isFormData = (data) =>
  typeof FormData !== 'undefined' && data instanceof FormData;

/** Let axios set multipart boundary */
const formDataConfig = { headers: { 'Content-Type': undefined } };

const specialOffersService = {
  getAll: (params) =>
    request.get('dashboard/admin/special-offers/paginate', { params }),
  getAllFlat: (params) =>
    request.get('dashboard/admin/special-offers/all', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/special-offers/${id}`, { params }),
  create: (data) => {
    if (isFormData(data)) {
      return request.post(
        'dashboard/admin/special-offers',
        data,
        formDataConfig,
      );
    }
    return request.post('dashboard/admin/special-offers', data);
  },
  update: (id, data) => {
    if (isFormData(data)) {
      return request.put(
        `dashboard/admin/special-offers/${id}`,
        data,
        formDataConfig,
      );
    }
    return request.put(`dashboard/admin/special-offers/${id}`, data);
  },
  toggleStatus: (id) =>
    request.put(`dashboard/admin/special-offers/${id}/toggle-status`),
  deleteById: (id) => request.delete(`dashboard/admin/special-offers/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/special-offers/delete', { data: { ids } }),
  dropAll: () => request.get('dashboard/admin/special-offers/drop/all'),
};

export default specialOffersService;
